export function initSmoothScroll (container) {
  //
  // LENIS SCROLL
  //
  const lenis = new Lenis ({
    duration: 1.5,
    smoothWheel: true,
    lerp: 0.07,
  });
  lenis.on ('scroll', ScrollTrigger.update);

  gsap.ticker.add (time => {
    lenis.raf (time * 1000);
  });
  gsap.ticker.lagSmoothing (0);

  //function raf(time) {
  //lenis.raf(time);
  //requestAnimationFrame(raf);
  //}
  //requestAnimationFrame(raf);

  document.querySelectorAll ('a.goto[href^="#"]').forEach (anchor => {
    anchor.addEventListener ('click', function (e) {
      e.preventDefault ();
      lenis.scrollTo (this.getAttribute ('href'));
      $ ('.btn-hamburger').removeClass ('active');
      $ ('main').removeClass ('nav-active');
      $ ('.no-scroll-overlay').removeClass ('active');
      $ ('.btn-click').removeClass ('active');
    });
  });

  document.querySelectorAll ('.goto a[href^="#"]').forEach (anchor => {
    anchor.addEventListener ('click', function (e) {
      e.preventDefault ();
      lenis.scrollTo (this.getAttribute ('href'));
      $ ('.btn-hamburger').removeClass ('active');
      $ ('main').removeClass ('nav-active');
      $ ('.no-scroll-overlay').removeClass ('active');
      $ ('.btn-click').removeClass ('active');
    });
  });


  /////CARTA
  if (document.querySelector ('#carta')) {
    document.querySelectorAll ('#carta .filtro a[href^="#"]').forEach (anchor => {
    anchor.addEventListener ('click', function (e) {
      e.preventDefault ();
      document
        .querySelectorAll ('#carta .filtro a[href^="#"]')
        .forEach (link => {
          link.classList.remove ('active');
        });
      this.classList.add ('active');
      lenis.scrollTo (this.getAttribute ('href'), {
        offset: -120,
      });
    });
  });

    const links = document.querySelectorAll ('#carta .filtro a[href^="#"]');
    const sections = [...links]
      .map (link => document.querySelector (link.getAttribute ('href')))
      .filter (Boolean);
    links.forEach (link => {
      link.addEventListener ('click', function (e) {
        e.preventDefault ();
        links.forEach (item => item.classList.remove ('active'));
        this.classList.add ('active');
        lenis.scrollTo (this.getAttribute ('href'), {
          offset: -120,
        });
      });
    });
    ScrollTrigger.create ({
      trigger: '#carta',
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: () => {
        const scroll = window.scrollY + 190;
        let activeIndex = 0;
        sections.forEach ((section, index) => {
          const sectionTop =
            section.getBoundingClientRect ().top + window.scrollY;
          if (sectionTop <= scroll) {
            activeIndex = index;
          }
        });
        links.forEach ((link, index) => {
          link.classList.toggle ('active', index === activeIndex);
        });
      },
    });
  }

  if (document.querySelector ('#carta')) {
    const mobileFiltros = document.querySelector ('#carta .filtros-mobile');
    const toggle = mobileFiltros.querySelector ('.filtros-mobile-toggle');
    const menu = mobileFiltros.querySelector ('.filtros-mobile-menu');
    const toggleText = toggle.querySelector ('span');
    const links = mobileFiltros.querySelectorAll ('a[href^="#"]');

    toggle.addEventListener ('click', () => {
      toggle.classList.toggle ('active');
      menu.classList.toggle ('active');
    });

    links.forEach (link => {
      link.addEventListener ('click', function (e) {
        e.preventDefault ();

        links.forEach (item => item.classList.remove ('active'));
        this.classList.add ('active');

        toggleText.textContent = this.textContent;

        toggle.classList.remove ('active');
        menu.classList.remove ('active');

        lenis.scrollTo (this.getAttribute ('href'), {
          offset: -110,
        });
      });
    });
  }

  /////GALERIA
  if (document.querySelector ('#galeria')) {
    const galeria = document.querySelector ('#galeria');
    const items = document.querySelectorAll ('#galeria .mosaico-item');
    const links = document.querySelectorAll (
      '#galeria .filtro a, #galeria .filtros-mobile-menu a'
    );
    let filtrando = false;
    const filtrar = categoria => {
      if (filtrando) return;
      filtrando = true;
      const targetY =
        galeria.getBoundingClientRect ().top + window.scrollY - 100;
      if (Math.abs (window.scrollY - targetY) > 20) {
        lenis.scrollTo (galeria, {
          offset: -100,
          duration: 0.6,
          lock: true,
          easing: t => 1 - Math.pow (1 - t, 3),
        });
      }
      const visibles = [...items].filter (
        item => !item.classList.contains ('hide')
      );
      gsap.to (visibles, {
        opacity: 0,
        duration: 0.25,
        stagger: 0.01,
        onComplete: () => {
          items.forEach (item => {
            const match =
              categoria === 'all' || item.dataset.categoria === categoria;
            item.classList.toggle ('hide', !match);
            gsap.set (item, {opacity: 0});
          });
          ScrollTrigger.refresh ();
          const nuevos = [...items].filter (
            item => !item.classList.contains ('hide')
          );
          gsap.to (nuevos, {
            opacity: 1,
            duration: 0.4,
            stagger: 0.03,
            ease: 'power1.out',
            onComplete: () => {
              filtrando = false;
            },
          });
        },
      });
    };
    links.forEach (link => {
      link.addEventListener ('click', function (e) {
        e.preventDefault ();
        const categoria = this.dataset.filtro;
        links.forEach (a =>
          a.classList.toggle ('active', a.dataset.filtro === categoria)
        );
        filtrar (categoria);
      });
    });
  }
  if (document.querySelector ('#galeria')) {
    const mobileFiltros = document.querySelector ('#galeria .filtros-mobile');
    const toggle = mobileFiltros.querySelector ('.filtros-mobile-toggle');
    const menu = mobileFiltros.querySelector ('.filtros-mobile-menu');
    const toggleText = toggle.querySelector ('span');
    const links = mobileFiltros.querySelectorAll ('a[data-filtro]');
    toggle.addEventListener ('click', () => {
      toggle.classList.toggle ('active');
      menu.classList.toggle ('active');
    });
    links.forEach (link => {
      link.addEventListener ('click', function () {
        toggleText.textContent = this.textContent;
        toggle.classList.remove ('active');
        menu.classList.remove ('active');
      });
    });
  }
}
